import { AbstractPmsApiService } from "./abstract.service";
import { SCTHApiLog } from "../models";

/**
 * @class SCTHApiLogPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SCTHApiLog>}
 */
export class SCTHApiLogPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/scth-api-log(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SCTHApiLog}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SCTHApiLog(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<SCTHApiLog>>}
     */
    get(params = {}, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Property=} property
     * @param {SCTHApiLog=} log
     * @returns {Promise.<Boolean>}
     */
    resend(property, log) {

        const url = this.url({
            propertyId: property.id,
            id: log.id,
        });

        return this.http
            .get(url + '/resend', {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/scth-api-log.service.js